import {createRouter,createWebHistory} from 'vue-router'
import PaymentPage from '@/pages/payment/payment.vue'


export default createRouter({ 
    history: createWebHistory(),
    routes:[
        {
        path: '/',
        name: 'appIndex',
        component: () => import('@/pages/appIndex.vue'),
        }
        , 
        {
            path: '/details',
            name: 'details',
            component: () => ()=>import('@/pages/details/commonDetail.vue'),
        }, 
        // {
        //     path: '/triplist/',
        //     name: 'triplist',
        //     component: () => import('@/pages/triplist/triplist.vue'),
        // }, 
        {
            path: '/visa',
            name: 'visa',
            component: () => import('@/pages/visa/visa.vue'),
        }, 
     /*    {
            path: '/referral',
            name: 'referral',
            component: () => import('@/pages/referral/refer.vue'),
        },
        {
            path: '/network',
            name: 'network',
            component: () => import('@/pages/network/network.vue'),
        }, */ 
        {
            path: '/wallet',
            name: 'wallet',
            component: () => import('@/pages/wallet/wallet.vue'),
        },
        {
            path: '/flight',
            name: 'flight',
            component: () => import('@/pages/flight/flight.vue'),
        },
        {
            path: '/payment',
            name: 'payment',
            component: PaymentPage,
        },
        {
            path: '/booking',
            name: 'booking',
            component: () => import('@/pages/booking/booking.vue'),
        },
        {
            path: '/membership',
            name: 'membership',
            component: () => import('@/pages/membership/membership.vue'),
        },
        {
            path:'/booking/insurance',
            name:'insurance',
            component:()=>import('@/components/insurance/InsurancePage.vue')
        },
        {
            path:'/details',
            name:"details",
            component: ()=>import('@/pages/details/commonDetail.vue')
        },
        {
            path: '/order',
            name: 'order',
            component: () => import('@/pages/order/order.vue'),
        },



        {
            // /hotel/ is its own page entry; without the slash the request lands in this SPA, so reload into it.
            path: '/hotel',
            name: 'hotelRedirect',
            component: { render: () => null },
            beforeEnter: () => {
                window.location.replace('/hotel/' + window.location.search + window.location.hash)
                return false
            },
        },

        { path: '/:pathMatch(.*)*', name: 'commonDetail', component: ()=>import('@/pages/details/commonDetail.vue') },
    ] 
})  
